import script from "./InfoCandidateItems.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCandidateItems.vue?vue&type=script&setup=true&lang=js"

import "./InfoCandidateItems.vue?vue&type=style&index=0&id=4632d826&lang=css"
import "./InfoCandidateItems.vue?vue&type=style&index=1&id=4632d826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4632d826"]])

export default __exports__